import { useQuery } from 'react-query'

import { QueryKeys } from 'constants/queries'
import { getCourses } from 'api/lectures'
import { GetCoursesResponse } from 'models/lectures/ApiModels/lectures'
import { deserializeCourses } from 'serializers/lectures'
import { Courses } from 'models/lectures/EntityModels/lectures'

const useGetCourses = () =>
  useQuery(QueryKeys.COURSES, getCourses, {
    select: (data: GetCoursesResponse): Courses => deserializeCourses(data)
  })

export default useGetCourses
